import faLocale from 'element-ui/lib/locale/lang/fa' //引入element语言包 波斯语
const fa = {
  Login: {
    ToLogin: 'ورود',
    PhoneLogin: 'شماره تلفن همراه',
    EmailLogin: 'ورود ایمیل',
    PhonePlaceholder: 'لطفا شماره تلفن همراه خود را وارد کنید',
    EmailPlaceholder: 'Enter email',
    Code: 'کد تأیید',
    and: 'و',
    BeforeText: 'با ایجاد حساب شما موافقت و رعایت می کنید.',
    UserAgreement: 'توافقنامه کاربر',
    privacy: 'سیاست حفظ حریم خصوصی',
    errorMessage: 'کد تأیید اشتباه',
    readTitle: 'قرارداد زیر را بخوانید و موافقت کنید',
    readBefore: 'برای اطمینان از امنیت اطلاعات شخصی خود، لطفاً ابتدا مطالعه کنید و موافقت کنید.',
    cancel: 'لغو',
    agree: 'موافقت و ادامه',
    error1:'لطفا آدرس ایمیل معتبر را وارد کنید',
    error2:'لطفا شماره تلفن خود را وارد کنید',
    error3:'لطفا کد تایید را وارد کنید',
    success:'ورود موفق شد'
  },
  ...faLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default fa;
